package pl.decks.personal.styles

import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Suppress("unused")
object SiteLayout {
    object Breakpoint { // Kobweb defaults
        val sm = 30.cssRem
        val md = 48.cssRem
        val lg = 62.cssRem
        val xl = 80.cssRem
        val xxl = 96.cssRem
    }

    object Fraction {
        val none = 0.percent

        val Quarter = 25.percent
        val Half = 50.percent
        val All = 100.percent
    }

    object Space {
        val none = 0.px

        val XXXSmall = 0.1.cssRem
        val XXSmall = 0.25.cssRem
        val XSmall = 0.5.cssRem
        val Small = 0.75.cssRem
        val Medium = 1.cssRem
        val Large = 1.25.cssRem
        val XLarge = 1.5.cssRem
        val XXLarge = 2.cssRem
        val XXXLarge = 3.cssRem

        object Relative {
            val XXSmall = 0.25.em
            val XSmall = 0.5.em
            val Small = 0.75.em
            val Medium = 1.em
            val Large = 1.25.em
            val XLarge = 1.5.em
            val XXLarge = 2.em
        }
    }

    object Line {
        val none = 0.px

        val Hairline = 1.px
        val Normal = 2.px
        val Thick = 4.px
    }

    object Rounding {
        val none = 0.px

        val Small = 0.25.cssRem
        val Medium = 0.5.cssRem
        val Large = 1.cssRem
        val XLarge = 2.cssRem

        val Full = 999.px  // CSS trick to get a pill shape
    }

    object Offset {
        val none = 0.px

        val Small = 2.px
        val Medium = 4.px
        val Large = 6.px
        val XLarge = 8.px
        val XXLarge = 12.px
        val XXXLarge = 16.px
    }
}
